<template>
    <div class="fc-display-contents">
        <color-picker
            v-if="!state"
            :value="color"
            @input="onInput"
        />

        <color-picker
            v-if="state === 'hover'"
            :value="hoverColor"
            @input="onInput"
        />

        <color-picker
            v-if="state === 'selected'"
            :value="selectedColor"
            @input="onInput"
        />

        <color-picker
            v-if="state === 'matching'"
            :value="matchingColor"
            @input="onInput"
        />
    </div>
</template>

<script>
import baseOption from '@/options/mixins/base-option';
import colorData from '@/data/constants/colors';

export default {
    name: 'border-color',
    mixins: [baseOption],

    props: {
        state: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            color: '',
            hoverColor: '',
            selectedColor: '',
            matchingColor: '',
            tailwindDefinitionProp: 'borderColor',
        };
    },

    methods: {
        onInput(color) {
            const localColorProp = this.state ? `${ this.state }Color` : 'color';

            if (color === colorData.NO_COLOR_FLAG) {
                this[localColorProp] = '';
                this.removeFlexClass(this.state);
                this.onOptionChange();
                return;
            }

            const flexClassNew = this.addFlexClass({
                value: color,
                state: this.state,
            });

            this[localColorProp] = color;
            this.onOptionChange(flexClassNew);
        },

        onSelectedElement() {
            this.setDefaultColor();
        },
    },
};
</script>
